import { currencyFormat } from 'common/helpers/numberHelper';

const TaxesIncludedInPrice = (props) => {
  const { taxes, settings } = props;
  if (!taxes) {
    return null;
  }
  const taxInclude = taxes.filter((tax) => tax.isIncludedInPrice === true);
  return (
    <>
      {taxInclude.map((tax) => (
        <div key={tax.id}>
          <div>{tax.title} Included In Price:</div>
          <div>{currencyFormat(tax.price, settings)}</div>
        </div>
      ))}
    </>
  );
};

export default TaxesIncludedInPrice;
